import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../../../atoms/buttons/Button';
import { bottomLinkStyle, closeButton } from '../../../components/common/CommonStyle';
import { VerifiedIcon } from '../../../atoms/icons/IDVIcons';
import JoinSkipButton from '../../../components/join/JoinSkipButton';
import { setShowSelfieVerificationWall, setSVWallByGetSelfieVerified } from '../../../actions/profileActions';
import { RootState } from '../../../store';
import { s3BucketContentDir } from '../../../config/Master';
import breakpoints from '../../../theme/material/breakpoints';
import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
import {
  ButttonWrapper,
  ClosedButton,
  Description,
  ElipseDiv,
  HeadingWrapper,
  List,
  SelfieImageWrapper,
  Title,
  buttonCustomStyle,
  defaultModalStyle,
  iconStyle,
} from './VerificationModalStyle';
import { isDarkMode } from '../../../utils/helpers';

const SvGMPhoto = `${s3BucketContentDir}idv/SelfieVerificationGM.png`;
const SvAMPhoto = `${s3BucketContentDir}idv/SelfieVerificationAM.png`;

ReactModal.setAppElement('body');

const setModalStyle = (customStyle: { overlay: any; content: any }, isMobile: boolean, darkMode: boolean) => {
  const customOverlay = customStyle.overlay || {};
  const customContent = customStyle.content || {};

  return {
    overlay: {
      ...customOverlay,
    },
    content: {
      ...customContent,
      top: isMobile ? 20 : 72,
      padding: isMobile ? '20px 0px 30px 0px' : '20px 30px 30px 30px',
      maxWidth: isMobile ? '345px' : '450px',
      maxHeight: isMobile ? '90vh' : '732px',
      height: isMobile ? 'auto' : 'auto', // allow content to define height
      border: darkMode ? '1px solid #6c6c6c' : 'none',
    },
  };
};

const Content = styled('div')({
  margin: '0px 30px 0px 50px',
  [breakpoints.down(1024)]: {
    margin: '0px 30px 0px 30px',
  },
});

interface ConfirmVerificationModalProps {
  onClose: any;
  hideClose?: boolean;
  [keys: string]: any;
}

const ConfirmSelfieVerificationModal = ({
  onClose,
  hideClose,
  ...rest
}: ConfirmVerificationModalProps): ReactElement => {
  const dispatch = useDispatch();
  const {
    profile: {
      data: { gender },
    },
  } = useSelector((state: RootState) => state.profile);

  const { isMobile } = useMediaBreakpoints();
  const darkMode = isDarkMode();

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ReactModal
      style={setModalStyle(defaultModalStyle(), isMobile, darkMode)}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      {...rest}
    >
      {!hideClose && (
        <ClosedButton onClick={onClose}>
          <SvgIcon component={CancelRounded} style={closeButton} />
        </ClosedButton>
      )}

      <SelfieImageWrapper>
        <ElipseDiv>
          <img src={gender === 'Male' ? SvGMPhoto : SvAMPhoto} alt="gender_photo" />
        </ElipseDiv>
      </SelfieImageWrapper>
      <Content>
        <HeadingWrapper
          style={{
            justifyContent: 'flex-start',
          }}
        >
          <Title style={{ display: 'inherit', margin: '0px 8px 0px 0px' }}>Get</Title>
          <VerifiedIcon customStyle={iconStyle} fillColor={'#E2C92D'} />
          <Title>Verified by Selfie!</Title>
        </HeadingWrapper>
        <Description>Show everyone you’re the real deal by verifying your profile with a selfie! </Description>
        <List>
          <li>Fast, safe and convenient</li>
          <li>Help keep WhatsYourPrice free from flakes and snakes</li>
          <li>Foster trust and get more offers</li>
          <li>
            Show off with a <span style={{ fontWeight: 700 }}>gold profile badge </span>
          </li>
          <li>
            <span style={{ fontWeight: 700 }}>It’s completely FREE!</span>
          </li>
        </List>
        <ButttonWrapper>
          <Button
            buttonType="primaryRed"
            onClick={() => {
              dispatch(setShowSelfieVerificationWall(true));
              dispatch(setSVWallByGetSelfieVerified(true));
              onClose();
            }}
            customStyle={buttonCustomStyle}
          >
            Start Selfie Verification
          </Button>
          <JoinSkipButton
            dataTestId="maybe-later-link"
            label="Maybe later"
            customWrapperStyle={{ textAlign: 'center', marginTop: 10 }}
            customStyle={{ ...bottomLinkStyle, fontSize: '11px', fontWeight: 400 }}
            onClick={onClose}
          />
        </ButttonWrapper>
      </Content>
    </ReactModal>
  );
};

export default ConfirmSelfieVerificationModal;
